import { createContext } from "react";

type AddressValidationContextType = {
	isAddressValidation: boolean;
	isShowBusinessWarningTooltip?: boolean;
	ownerIndexAddressValidation?: { [key: string]: any }[] | null;
};

const AddressValidationContext = createContext<AddressValidationContextType>({
	isAddressValidation: false,
	isShowBusinessWarningTooltip: false,
	ownerIndexAddressValidation: [],
});

export default AddressValidationContext;
